<template>
    <div @mouseenter="isshowing(1)" @mouseleave="isshowing(2)" style="border: 1px solid #bbb;border-radius: 2px;">
        <table class="table">
            <tbody>
                <tr v-for="(item,index) in this.rankkeywords" :key="index">
                    <td><span @click="checkbaidurank(item.checkwords)" class="wordshow">{{item.checkwords}}</span><span @click="closekeywords(index)" class="close">×</span></td>
                </tr>
                <tr style="background-color: rgb(246, 247, 249);">
                    <td style="padding:10px;"><span @click="closeall()" class="clearword">清空历史记录</span><span style="float: right;"><button @click="allcheck()" class="btn1">查询全部</button></span></td>
                </tr>
            </tbody>
            
        </table>
    </div>
</template>
<script>
    export default {
        name: "BaiduRankList",
        props: {
            domain:String,
        },
        data() {
            return {
                rankkeywords:[]
            }
        },

        mounted() {
            if(localStorage.getItem(this.domain+'_baiduranklist'))
            {
                this.rankkeywords=JSON.parse(localStorage.getItem(this.domain+'_baiduranklist'));
                this.rankkeywords=this.rankkeywords.reverse()
            }
        },
        methods:{
            closekeywords(index){
                this.rankkeywords.splice(index,1);
                localStorage.setItem(this.domain+'_baiduranklist',JSON.stringify(this.rankkeywords));
            },
            checkbaidurank(keywords)
            {
                this.$messenger.addTarget(window.parent, 'parent');
                this.$messenger.targets['parent'].send("Check-Searc-BaiduRank", {keyword: keywords});
                this.changeFather();
            },
            closeall(){
                this.rankkeywords=[]
                localStorage.setItem(this.domain+'_baiduranklist',[]);
                this.changeFather();
            },
            allcheck()
            {
                this.$messenger.addTarget(window.parent, 'parent');
                this.$messenger.targets['parent'].send("Check-Searc-BaiduRank", {keyword: this.rankkeywords,SearcType:2});
                this.changeFather();
            },
            changeFather(){
             this.$emit("listenTochildEvent",false);
            },
            isshowing(istype){
              istype===1?this.$emit("listenToIshow",true):this.$emit("listenToIshow",false);
            }
        }
    }
</script>


<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .table {
    width: 100%;
    border: none;

    td {
      border: none;
      text-align: left;
      line-height: 26px;
      font-size: 12px;
      font-weight: normal;
      .ellipsis();
      &:nth-child(1) {
        width: 90%;
      }
      &:nth-child(2) {
        width: 10%;
      }
      .wordshow{
        cursor: pointer;
        margin-left: 10px;
      }
      .close{
        float: right;
        cursor: pointer;
        width: 20px;
      }
      .btn1{
        padding: 3px 8px;
        border-radius: 4px;
        background-color:white;
        border: 1px solid #0665f6;
        cursor: pointer;
        font-size: 12px;
      }
      .clearword{
        font-size: 12px;
        color: #0665f6;
        text-decoration: underline;
        cursor: pointer;
        letter-spacing: 1px;
      }
    }
    tbody{
      tr{
        &:hover{
          background-color: rgb(240, 238, 238)
        }
      }
    }
    td {
      &:nth-child(1) {
        color: #343434;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BaiduRankList.vue